import React, {Component} from 'react';
import {Route} from "react-router-dom";
import Landing from "./LandingPage/Landing";
import Pillcards from "./Pillcards";
import PatientView from "./Pillcards/PatientView";
import Smilow from "./Pillcards/Smilow";
import Login from "./Login";
import "./App.css"

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      "diseases": ["Psychiatry"]
    };
  }

  render() {
    // todo: change getpills type
    return (<div> {/*className="App">*/}
      <Route exact={true} path="/" render={props => (<Landing {...props} diseases={this.state.diseases}/>)}/>
      <Route path="/psychiatry/" render={props => (<Pillcards {...props} type='psychiatry' va={false}/>)}/>
      <Route path="/diabetes/" render={props => (<Pillcards {...props} type='diabetes' va={false}/>)}/>
      <Route path="/diabetes_va/" render={props => (<Pillcards {...props} type='diabetes' va={true} />)}/>
      <Route path="/addiction/" render={props => (<Pillcards {...props} type='addiction'va={false} />)}/>
      <Route path="/getpills/:id/:hashURL/" render={props => <PatientView {...props} type='psychiatry' va={false}/>}/>
      <Route path="/smilow/" render={props => <Smilow {...props}/>}/>
      <Route path="/login/" render={props => <Login {...props}/>}/>
    </div>);
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js